import { render, staticRenderFns } from "./LoadPanel.vue?vue&type=template&id=12a7e348&"
import script from "./LoadPanel.vue?vue&type=script&lang=ts&"
export * from "./LoadPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports